import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    ImageBackground,
    Modal,
    Animated,
    Text,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import { min } from "moment";
let height = Dimensions.get("window").height;
let width = Dimensions.get("window").width;
let marginTop = 230;
let styles = {};
let isMobile = false;
let scale = 1;
const imgFile = require("../images/orderNow/image.png");
const backArrow = require("../images/CheckOut/BackArrow.png");
const imgGreenVector = require("../images/Shop/AddVector.png");
const plus = require("../images/Shop/plus.png");
const minus = require("../images/Shop/minus.png");
const giftIcon = require("../images/CheckOut/greengiftIcon.png");
const removeItem = require("../images/CheckOut/RemoveOrder.png");
const cameraImg = require("../images/CheckOut/Camera.png");
const holdIcon = require("../images/CheckOut/holdIcon.png");
const closeIcon = require("../images/CheckOut/closeIcon.png");
const bin = require("../images/CheckOut/bin.png");

class CheckoutMini extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            order: {},
            itemQty: '',
            itemsInBasket: [],
            accountOnHold: true,
            showOnHoldPopUp: false,
            highlightedItems: {}, // Track highlighted items
            previousProducts: [], // Track previous products for comparison
        };

        // Animated values for smooth highlighting
        this.highlightAnimations = {};
    }
    Pressables = {};

    async componentDidMount() {
        this.basketLastUpdate = await Commons.getBasketLastUpdate();
        this.loadData();
        this.updateChecker = setInterval(async () => {
            const lastUpdate = await Commons.getBasketLastUpdate();
            if (!this.basketLastUpdate || (lastUpdate && lastUpdate > this.basketLastUpdate)) {
                this.basketLastUpdate = lastUpdate;
                await this.loadDataWithHighlight();
            }
        }, 500);
    } componentWillUnmount() {
        clearInterval(this.updateChecker);
    }

    loadData = async () => {
        // loaderHandler.showLoader(STRINGS.loading, this);
        const parsedItems = await Commons.getBasketItems();
        try {
            // const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
            // const orderResp = await Commons.calculateOrderPrice(parsedItems);
            this.setState({
                previousProducts: this.state.products, // Store previous products
                products: parsedItems,
                order: {}
            });
        } catch (e) {
            console.log('Failed to parse ITEMS_IN_BASKET:', e);
            console.log(parsedItems);
        }

        // loaderHandler.hideLoader();
    }

    loadDataWithHighlight = async () => {
        const previousProducts = this.state.products;
        const parsedItems = await Commons.getBasketItems();

        try {
            // Compare products to find changes
            const updatedItemIds = this.findUpdatedItems(previousProducts, parsedItems);

            // Set highlighted items and start animations
            const highlightedItems = {};
            updatedItemIds.forEach(id => {
                highlightedItems[id] = true;

                // Create animation for this item if it doesn't exist
                if (!this.highlightAnimations[id]) {
                    this.highlightAnimations[id] = new Animated.Value(0);
                }

                // Start highlight animation
                Animated.sequence([
                    Animated.timing(this.highlightAnimations[id], {
                        toValue: 1,
                        duration: 300,
                        useNativeDriver: false,
                    }),
                    Animated.delay(1500), // Keep highlighted for 1.5 seconds
                    Animated.timing(this.highlightAnimations[id], {
                        toValue: 0,
                        duration: 300,
                        useNativeDriver: false,
                    })
                ]).start();
            });

            this.setState({
                previousProducts: previousProducts,
                products: parsedItems,
                order: {},
                highlightedItems: highlightedItems
            });

            // Scroll to the first updated item if any
            if (updatedItemIds.length > 0) {
                this.scrollToUpdatedItem(updatedItemIds[0]);
            }

            // Remove highlight after 3.2 seconds (slightly longer than animation)
            setTimeout(() => {
                this.setState({ highlightedItems: {} });
            }, 3200);

        } catch (e) {
            console.log('Failed to parse ITEMS_IN_BASKET:', e);
            console.log(parsedItems);
        }
    }

    findUpdatedItems = (previousProducts, currentProducts) => {
        const updatedItems = [];

        currentProducts.forEach(currentItem => {
            const previousItem = previousProducts.find(p => p.ID === currentItem.ID);

            if (!previousItem) {
                // New item added
                updatedItems.push(currentItem.ID);
            } else if (previousItem.qty !== currentItem.qty) {
                // Quantity changed
                updatedItems.push(currentItem.ID);
            }
        });

        return updatedItems;
    }

    scrollToUpdatedItem = (itemId) => {
        // Find the index of the updated item
        const itemIndex = this.state.products.findIndex(p => p.ID === itemId);

        if (itemIndex >= 0 && this.mainScrollView) {
            // Calculate scroll position based on device type
            const itemHeight = 140; // Approximate height per item
            const scrollPosition = itemIndex * itemHeight;

            // Add a small delay to ensure the view has rendered
            setTimeout(() => {
                if (this.mainScrollView && this.mainScrollView.scrollTo) {
                    // Scroll to the item with some padding
                    this.mainScrollView.scrollTo({
                        y: Math.max(0, scrollPosition),
                        animated: true
                    });
                }
            }, 100);
        }
    }


    renderHeader = () => {
        const { showProductsDetails } = this.props;
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between", backgroundColor: '#fff' }}>
                <TouchableOpacity onPress={() => {
                    if (this.props.showCheckout) {
                        this.props.showCheckout(false);
                        return;
                    }
                    window.history.back()
                }}>
                    <Image source={backArrow} style={{
                        width: 16,
                        height: 16,
                        padding: 1,
                        resizeMode: "contain",
                        tintColor: Styles.appColor1
                    }} />
                </TouchableOpacity>

                <Text style={[AppStyles.filtersHeaderStyle, { fontSize: 16, fontWeight: '500' }]}>{STRINGS.checkOut_cart}</Text>

                <TouchableOpacity onPress={() => window.location = './profile'}>
                    {/* <Image source={cartIcon} style={{ width: 20.203, height: 20, tintColor: Styles.appColor1 }}></Image> */}
                </TouchableOpacity>
            </View>
        )
    }

    renderDeleteAllButton = () => {
        return (
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 16, marginBottom: 8, width, marginTop: 36,
            }}>
                <Text style={
                    [
                        AppStyles.desktopCartName,
                        {
                            // marginHorizontal: 50,
                            // marginBottom: 15,
                            fontSize: 20 * scale
                        }
                    ]}>{STRINGS.desktop_cart}</Text>
                <TouchableOpacity style={{ flexDirection: 'row', gap: 4, alignItems: 'center' }}
                    onPress={() => { this.clearAllItems(); }}>
                    <Text style={[AppStyles.clearCheckOut,]} > {STRINGS.clear_checkOut} </Text>
                    <Image source={bin} style={{ width: 13.321, height: 14.154, tintColor: '#9197B3' }} />
                </TouchableOpacity>
            </View>
        )
    }

    clearAllItems = async () => {
        await Commons.saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify([]));
        this.loadData();
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={[styles.container, { backgroundColor: '#F7F7F7', height }]}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {this.renderHeader()}
                {Commons.loadFonts(this, false)}
                {this.popUpAccountOnHold()}
                <ScrollView
                    style={{}}
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, backgroundColor: '#ffffff' }}>
                        {this.renderPart1Mobile()}
                        <View style={{ height: 20, backgroundColor: '#F7F7F7', borderTopLeftRadius: 25, borderTopRightRadius: 25 }} />
                    </View>
                    {this.renderPart2Mobile()}
                    {/* {Commons.renderAppFooter({}, this)} */}
                </ScrollView>
                {this.renderPlaceOrderButton()}
            </View >
        );
    }

    render() {
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
        }
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        const menuScale = Commons.getMenuScale();
        width = 340 * menuScale;
        scale = 1;
        height = (Commons.getDesktopHeight());
        styles = this.styles();
        return (
            <View style={{ width, height: 300 }}>
                {/* Top gradient overlay */}
                <View style={{
                    position: 'absolute',
                    top: 65,
                    left: 0,
                    right: 0,
                    height: 40,
                    background: 'linear-gradient(rgba(255, 255, 255, 0.9), transparent)',
                    pointerEvents: 'none',
                    zIndex: 1
                }} />
                {this.renderDeleteAllButton()}
                <ScrollView
                    showsVerticalScrollIndicator={false}
                    style={{}}
                    ref={ref => this.mainScrollView = ref}
                >
                    {/* {this.renderPart1Mobile()} */}
                    {this.renderPart1()}
                    {/* {this.renderPart2Mobile()} */}
                </ScrollView>
                {/* Bottom gradient overlay */}
                <View style={{
                    position: 'absolute',
                    bottom: 45,
                    left: 0,
                    right: 0,
                    height: 40,
                    background: 'linear-gradient(transparent, rgba(255, 255, 255, 0.9))',
                    pointerEvents: 'none'
                }} />
                {this.renderPlaceOrderButton()}
            </View>
        );
    }




    updateProducts = async (products) => {
        await Commons.saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify(products));
        await Commons.calculateOrderPrice(this);
        this.loadData();
        if (this.props.self.shop) {
            const shop = this.props.self.shop;
            shop.setState({ featuredItems: shop.state.featuredItems.slice(), bestSellers: shop.state.bestSellers.slice() });
        }
    }

    popUpAccountOnHold = () => {
        return (
            <Modal
                visible={this.state.showOnHoldPopUp}
                transparent={true}
                animationType="fade"
                onRequestClose={() => this.setState({ showOnHoldPopUp: false })}
            >
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'rgba(255,255,255,0.4)', // white with opacity
                        justifyContent: 'center',
                        alignItems: 'center',

                    }}
                >
                    <View
                        style={{
                            backgroundColor: '#fff',
                            padding: 24,
                            width: width * 0.8,
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 16,
                            borderWidth: 1,
                            borderColor: 'rgba(215, 215, 215, 0.50)',
                        }}
                    >
                        <TouchableOpacity
                            style={{
                                position: 'absolute',
                                right: 12,
                                top: 12,
                                zIndex: 10,
                            }}
                            onPress={() => this.setState({ showOnHoldPopUp: false })}
                        >
                            <Image source={closeIcon} style={{ width: 16, height: 16 }} />
                        </TouchableOpacity>
                        <Text style={[AppStyles.accountHoldHeader, { marginTop: 15 }]}>
                            {STRINGS.account_onHold}
                        </Text>
                        <Text style={[AppStyles.accountHoldText, { marginBottom: 24, marginTop: 16 }]}>
                            {STRINGS.acc_hold_message}
                        </Text>
                        <TouchableOpacity style={[AppStyles.loginButtonStyles, { paddingVertical: 10, paddingHorizontal: 32, }]}
                        >
                            <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.sales_rep}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>
        )
    }

    renderPart1 = () => {
        const menuScale = Commons.getMenuScale();
        const descMarginTop = 13 * (1.2 / menuScale);
        const itemContainerHeight = 140;
        const itemImageSize = isMobile ? 75 : 87.889;
        const itemInfoWidth = isMobile ? width * 0.5 - 30 : 140 * menuScale;
        const removeIconSize = isMobile ? 12 : 8;
        const removeIconMargin = isMobile ? 0 : 10;
        const removeIconTop = isMobile ? 0 : 2;
        const qtyBgColor = isMobile ? '#6BA461' : '#fff';
        const qtyTextColor = isMobile ? '#FFF' : Styles.appColor1;
        const qtyBoxBg = isMobile ? undefined : '#F0F6FC';
        const qtyBoxPadding = isMobile ? undefined : 8;
        const qtyBoxMinWidth = isMobile ? undefined : 28;
        const qtyBoxPaddingVertical = isMobile ? undefined : 2;
        const bonusIconSize = isMobile ? 12 : 16;
        const bonusTextMargin = isMobile ? 4 : 4;
        const priceMarginTop = isMobile ? 0 : 2;

        const cartItems = this.state.products.map((item, index) => {
            const isHighlighted = this.state.highlightedItems[item.ID];
            const animatedValue = this.highlightAnimations[item.ID] || new Animated.Value(0);

            const highlightStyle = {
                backgroundColor: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['#FFF', '#E8F5E8']
                }),
                // borderColor: animatedValue.interpolate({
                //     inputRange: [0, 1],
                //     outputRange: ['transparent', '#6BA461']
                // }),
                // borderWidth: animatedValue.interpolate({
                //     inputRange: [0, 1],
                //     outputRange: [0, 2]
                // }),
                // transform: [{
                //     scale: animatedValue.interpolate({
                //         inputRange: [0, 1],
                //         outputRange: [1, 1.02]
                //     })
                // }]
            };

            return (
                <Animated.View key={item.ID} style={[{
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    paddingVertical: 20,
                    paddingHorizontal: 2,
                    height: itemContainerHeight,
                    width: isMobile ? width - 16 : width,
                    borderRadius: isMobile ? 8 : 0,
                }, highlightStyle]}>
                    {/* Product Image */}
                    <TouchableOpacity style={{ justifyContent: 'center', alignItems: 'center', marginLeft: 20 * scale, marginRight: 10 }}
                        onPress={() => {
                            if (this.props.showProductDetails) {
                                this.props.showProductDetails(item);
                            }
                        }}>
                        <Image
                            source={item.IMG === '' ? imgFile : item.IMG}
                            style={{
                                width: itemImageSize,
                                height: itemImageSize,
                                borderRadius: 8,
                                resizeMode: 'contain'
                            }}
                        />
                    </TouchableOpacity>
                    {/* Product Info and Actions */}
                    <View style={{
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        width: itemInfoWidth,
                    }}>
                        {/* Top Row: Name and Remove */}
                        <TouchableOpacity style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            width: itemInfoWidth
                        }} onPress={() => {
                            if (this.props.showProductDetails) {
                                this.props.showProductDetails(item);
                            }
                        }}>
                            <Text style={[AppStyles.checkOutMiniDescStyle, { flex: 1, height: 26 }]} numberOfLines={2}>{item.NAME.toLowerCase()}</Text>
                            <TouchableOpacity
                                onPress={() => {
                                    this.setState(prevState => {
                                        const products = prevState.products.filter(p => p.ID !== item.ID);
                                        this.updateProducts(products);
                                        return { products };
                                    });
                                }}
                                style={{ marginLeft: removeIconMargin, marginTop: removeIconTop }}
                            >
                                <Image source={removeItem} style={{ width: removeIconSize, height: removeIconSize, tintColor: Styles.appColor1 }} />
                            </TouchableOpacity>
                        </TouchableOpacity>
                        <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: descMarginTop }}>
                            <View style={[
                                AppStyles.noBonusStyle,
                                {
                                    flexDirection: 'row',
                                    gap: isMobile ? 5 : 15,
                                    padding: 4,
                                    paddingHorizontal: 8,
                                    alignItems: 'center',
                                    backgroundColor: qtyBgColor,
                                    borderRadius: 20,
                                    justifyContent: 'space-between',
                                    width: 95
                                }
                            ]}>
                                <TouchableOpacity
                                    style={{ zIndex: 3, width: 8, paddingVertical: 5 }}
                                    onPress={() => {
                                        this.setState(prevState => {
                                            const cartQty = { ...(prevState.cartQty || {}) };
                                            cartQty[item.ID] = Math.max((cartQty[item.ID] || item.qty || 0) - 1, 0);
                                            // Also update products array qty
                                            const products = prevState.products.map(p =>
                                                p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                            );
                                            if (cartQty[item.ID] <= 0) {
                                                products.splice(index, 1);
                                            }
                                            this.updateProducts(products);
                                            return { products };
                                        });
                                    }}>
                                    <Image source={minus} style={{ width: 6, height: 1.2, tintColor: qtyTextColor }} />
                                </TouchableOpacity>
                                <View style={{
                                    zIndex: 3,
                                    backgroundColor: qtyBoxBg,
                                    paddingHorizontal: 12,
                                    paddingVertical: 6,
                                    minWidth: qtyBoxMinWidth,
                                    alignItems: 'center',
                                    borderRadius: 3
                                }}>
                                    <Text style={[AppStyles.featuredItemsQtyMiniStyle, { color: qtyTextColor }]}>{item.qty || 0}</Text>
                                </View>
                                <TouchableOpacity
                                    style={{ zIndex: 3, width: 8, height: 8 }}
                                    onPress={() => {
                                        // Increase qty for this item
                                        this.setState(prevState => {
                                            const cartQty = { ...(prevState.cartQty || {}) };
                                            cartQty[item.ID] = (cartQty[item.ID] || item.qty || 0) + 1;
                                            const products = prevState.products.map(p =>
                                                p.ID === item.ID ? { ...p, qty: (p.qty || 0) + 1 } : p
                                            );
                                            this.updateProducts(products);
                                            return { products };
                                        });
                                    }}>
                                    <Image source={plus} style={{ width: 8, height: 8, tintColor: qtyTextColor }} />
                                </TouchableOpacity>
                            </View>
                            {/* Bonus */}
                            {item.BONUS !== '' && item.BONUS > 0 && (
                                <View style={{ flexDirection: 'row', alignItems: 'center', marginLeft: 25 }}>
                                    <Image source={giftIcon} style={{ width: bonusIconSize, height: bonusIconSize }} />
                                    <Text style={[AppStyles.giftText, { marginLeft: bonusTextMargin }]}>+ {item.BONUS}</Text>
                                </View>
                            )}
                        </View>
                        {/* Price */}
                        <Text style={[AppStyles.checkOutPriceMiniStyle, {
                            fontSize: 10
                            , marginTop: descMarginTop
                            , color: Styles.appColor1
                        }]}>{item.PHARMACY_PRICE} JOD</Text>
                    </View>
                </Animated.View>
            );
        });

        return (
            <View style={{ backgroundColor: '#FFF', paddingBottom: 40, position: 'relative' }}>
                {cartItems.map((item, idx) => (
                    <View key={idx}>
                        {item}
                        {/* Separator */}
                        {idx < cartItems.length - 1 && (
                            <View style={{ height: 1, backgroundColor: '#F0F0F0', marginHorizontal: 8 }} />
                        )}
                    </View>
                ))}

            </View>
        );
    }

    renderPart1Mobile = () => {
        const cartItems = this.state.products.map((item, index) => {
            var bonusStyle = AppStyles.wBonusStyle;
            if (item.BONUS === '') {
                bonusStyle = AppStyles.noBonusStyle;
            }
            const isHighlighted = this.state.highlightedItems[item.ID];
            const animatedValue = this.highlightAnimations[item.ID] || new Animated.Value(0);

            const highlightStyle = {
                backgroundColor: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['transparent', '#E8F5E8']
                }),
                borderColor: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['transparent', '#6BA461']
                }),
                borderWidth: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, 2]
                }),
                paddingHorizontal: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, 8]
                }),
                paddingVertical: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, 4]
                }),
                transform: [{
                    scale: animatedValue.interpolate({
                        inputRange: [0, 1],
                        outputRange: [1, 1.02]
                    })
                }]
            };

            return (
                <Animated.View style={[{
                    flexDirection: 'row',
                    width: isMobile ? width - 20 : 390,
                    marginVertical: 10,
                    borderRadius: 8,
                }, highlightStyle]}>
                    <TouchableOpacity
                        style={{ position: 'absolute', right: 12, top: 0, zIndex: 10 }}
                        onPress={() => {
                            this.setState(prevState => {
                                const cartQty = { ...(prevState.cartQty || {}) };
                                cartQty[item.ID] = 0;
                                // Also update products array qty
                                const products = prevState.products.map(p =>
                                    p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                );
                                if (cartQty[item.ID] <= 0) {
                                    products.splice(index, 1);
                                }
                                this.updateProducts(products);
                                return { products };
                            });

                        }}>
                        <Image source={removeItem} style={{ width: 12, height: 12 }} />
                    </TouchableOpacity>


                    <TouchableOpacity style={{ height: 75.772, width: 92.974, borderRadius: 5.256, }}>
                        {item.BONUS !== '' && item.NEXT_BONUS > 0 && (
                            <View style={{
                                position: 'absolute',
                                top: 1,
                                left: 1,
                                backgroundColor: '#EF897D',
                                borderTopLeftRadius: 4.107,
                                borderBottomRightRadius: 4.107,
                                paddingVertical: 2,
                                zIndex: 10,
                                width: 65.857,
                                height: 23,
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <Text style={{ color: '#FFF', fontSize: 7.886, fontWeight: '700', }}>Bonus {item.NEXT_BONUS_TEXT}</Text>
                            </View>
                        )}
                        <Image source={item.IMG === '' ? imgFile : item.IMG} style={{ width: '100%', height: '100%', }} resizeMode="contain" />
                    </TouchableOpacity>
                    <View style={{ justifyContent: 'center' }}>
                        <Text style={[AppStyles.checkOutDescStyle, { width: 135, color: '#FFF', fontSize: 12.974, color: Styles.appColor1 }]}>{item.NAME.toLowerCase()}</Text>
                        <Text style={[AppStyles.checkOutPriceMiniStyle, { fontSize: 10, color: Styles.appColor1 }]}>{item.PHARMACY_PRICE}</Text>
                        {item.BONUS !== '' && item.NEXT_BONUS_TEXT !== '' && (
                            <TouchableOpacity
                                onPress={() => {
                                    this.setState(prevState => ({
                                        bonusAdded: {
                                            ...(prevState.bonusAdded || {}),
                                            [item.ID]: true
                                        }
                                    }));
                                    Commons.addItemsToBasket(this, item, item.ID, item.NEXT_BONUS);
                                    this.setState(prevState => {
                                        const products = prevState.products.map(p =>
                                            p.ID === item.ID ? { ...p, qty: item.NEXT_BONUS } : p
                                        );
                                        this.updateProducts(products);
                                        return { products };
                                    });
                                }}
                                style={{
                                    width: 185,
                                    paddingVertical: 4, justifyContent: "center", alignItems: 'center',
                                    borderRadius: 8.631, backgroundColor: '#EF897D', flexDirection: 'row',
                                }}>
                                <Image source={giftIcon} style={{ height: 12.084, width: 12.016, marginHorizontal: 13.8 }} />
                                <Text style={[AppStyles.checkOutDescStyle, { width: 135, color: '#FFF', fontSize: 12.974, }]}>{item.NEXT_BONUS_TEXT_LONG}</Text>
                            </TouchableOpacity>
                        )}
                    </View>
                    <View style={[AppStyles.noBonusStyle, {
                        position: 'absolute',
                        right: 5, top: 18, justifyContent: 'center', alignItems: 'center'
                    }]}>
                        {item.BONUS !== '' && item.BONUS > 0 && (
                            <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', gap: 4, marginTop: 50 }}>
                                <Image source={giftIcon} style={{ width: 12.016, height: 12.084, tintColor: '#6BA461' }} />
                                <Text style={[AppStyles.giftText]}>+ {item.BONUS}</Text>
                            </View>
                        )}
                        <View style={[AppStyles.noBonusStyle, {
                            flexDirection: 'row', gap: 5, padding: 4, paddingHorizontal: 8,
                            alignItems: 'center', backgroundColor: '#6BA461', borderRadius: 20, justifyContent: 'space-between', zIndex: 3
                        }]}>
                            <TouchableOpacity style={{ zIndex: 3, width: 12, paddingVertical: 5, }}
                                onPress={() => {
                                    this.setState(prevState => {
                                        const cartQty = { ...(prevState.cartQty || {}) };
                                        cartQty[item.ID] = Math.max((cartQty[item.ID] || item.qty || 0) - 1, 0);
                                        // Also update products array qty
                                        const products = prevState.products.map(p =>
                                            p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                        );
                                        if (cartQty[item.ID] <= 0) {
                                            products.splice(index, 1);
                                        }
                                        this.updateProducts(products);
                                        return { products };
                                    });
                                }}>
                                <Image source={minus} style={{ width: 12, height: 1.2, tintColor: '#FFF' }} />
                            </TouchableOpacity>
                            <View style={{ zIndex: 3, }}>
                                <Text style={[AppStyles.featuredItemsQtyStyle]}>{item.qty || 0}</Text>
                            </View>
                            <TouchableOpacity style={{ zIndex: 3, width: 12, height: 12, }}
                                onPress={() => {
                                    // Increase qty for this item
                                    this.setState(prevState => {
                                        const cartQty = { ...(prevState.cartQty || {}) };
                                        cartQty[item.ID] = (cartQty[item.ID] || item.qty || 0) + 1;
                                        const products = prevState.products.map(p =>
                                            p.ID === item.ID ? { ...p, qty: (p.qty || 0) + 1 } : p
                                        );
                                        this.updateProducts(products);
                                        return { products };
                                    });

                                }}>
                                <Image source={plus} style={{ width: 12, height: 12, tintColor: '#FFF' }} />
                            </TouchableOpacity>
                        </View>
                    </View>
                </Animated.View>
            );
        });
        return (
            // <View style={{ marginTop: 34, marginHorizontal: 16,   gap: 16, alignSelf: 'stretch', backgroundColor: '#FFF',height: height / 2 }}>
            // <ScrollView>
            <View style={{ marginHorizontal: 8, alignSelf: 'stretch', backgroundColor: '#FFF' }}>
                {this.state.accountOnHold && isMobile && (
                    <TouchableOpacity
                        onPress={() => this.setState({ showOnHoldPopUp: true })}
                        style={{ justifyContent: 'flex-start', flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', borderRadius: 10, borderWidth: 1, borderColor: '#FFF', backgroundColor: '#F9DBDB', width: width - 25, height: 40, marginHorizontal: 8 }}>
                        <View style={{ flexDirection: 'row', marginHorizontal: 16, justifyContent: 'center', alignItems: 'center' }}>
                            <Image source={holdIcon} style={{ width: 15.574, height: 13.999, tintColor: Styles.appColor1, }} />
                            <Text style={[AppStyles.orderListText]}> {STRINGS.account_onHold}</Text>
                        </View>
                    </TouchableOpacity>
                )}
                <View style={{ marginTop: this.state.accountOnHold ? 16 : 0 }}>
                    {cartItems}
                </View>
            </View>
            // </ScrollView>
            // </View>
        )

    }


    renderPart2Mobile = () => {
        const orderSummaryTitles = [
            { title: STRINGS.checkOut_Subtotal, titleStyle: AppStyles.checkOutPaymentTerms, marginTop: 16, },
            // { title: STRINGS.checkOut_Discount, titleStyle: AppStyles.checkOutPaymentTerms, marginTop: 0, },
            { title: STRINGS.checkOut_Tax, titleStyle: AppStyles.checkOutPaymentTerms, marginTop: 0, },
            { title: STRINGS.checkOut_Estimated_Total, titleStyle: AppStyles.checkOutPaymentTermsBold, marginTop: 0, },
        ];
        return (
            <View style={{ height: 310, alignSelf: 'stretch', backgroundColor: isMobile ? undefined : '#FFF' }}>
                <View style={{ marginHorizontal: 16, gap: 4, alignSelf: 'stretch', width: isMobile ? width - 40 : 364 }}>
                    <Text style={[AppStyles.checkOutDelevery, {}]}>{STRINGS.checkOut_Delevery}</Text>
                    <Text style={[AppStyles.checkOutExpectedDate, {}]}>{STRINGS.checkOut_Expected_by} {this.state.order.EXPECTED_DATE} </Text>
                </View>

                <View style={{ marginHorizontal: 16, marginTop: 16, width: isMobile ? width - 40 : 364, borderTopWidth: 2, borderTopColor: '#444', flexDirection: 'row' }}>
                    <View style={{ gap: 4, alignSelf: 'stretch', width: '50%' }}>
                        <Text style={[AppStyles.checkOutDelevery, { marginTop: 16 }]}>{STRINGS.checkOut_Payment_Terms}</Text>
                    </View>
                    <View style={{ alignItems: 'flex-end', gap: 4, alignSelf: 'stretch', width: '50%' }}>
                        <View>
                            <Text style={[AppStyles.checkOutExpectedDate, { marginTop: 16, textAlign: 'right' }]}>{this.state.order.TERMS}</Text>
                        </View>
                    </View>
                </View>

                <View style={{ marginHorizontal: 16, marginTop: 16, width: isMobile ? width - 40 : 364, borderTopWidth: 2, borderTopColor: '#444', flexDirection: 'row' }}>
                    <View style={{ gap: 4, alignSelf: 'stretch', width: '50%' }}>
                        {orderSummaryTitles.map((item, idx) => (
                            <Text
                                key={idx}
                                style={[item.titleStyle, { marginTop: item.marginTop, color: idx === 3 ? Styles.appColor1 : undefined }]}
                            >
                                {item.title}
                            </Text>
                        ))}
                    </View>
                    <View style={{ alignItems: 'flex-end', gap: 4, alignSelf: 'stretch', width: '50%' }}>
                        <View>
                            <Text style={[AppStyles.checkOutPaymentTerms, { marginTop: 16, textAlign: 'right' }]}>{this.state.order.SUBTOTAL}</Text>
                            {/* <Text style={[AppStyles.checkOutPaymentTerms, {}]}>{this.state.order.DISCOUNT}</Text> */}
                            <Text style={[AppStyles.checkOutPaymentTerms, {}]}>{this.state.order.TAX}</Text>
                            <Text style={[AppStyles.checkOutPaymentTermsBold]}>{this.state.order.ESTIMATED_TOTAL}</Text>
                        </View>
                    </View>
                </View>
                <View style={{ width: isMobile ? width - 40 : 364, marginHorizontal: 16, borderWidth: 1, borderColor: '#444', marginTop: 16 }}></View>
            </View>
        )

    }

    renderPart2 = () => {

    }

    renderPlaceOrderButton = () => {
        const menuScale = Commons.getMenuScale();
        return (
            <TouchableOpacity style={[AppStyles.loginButtonStyles,
            {
                width: '100%',
                marginBottom: 0,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 20,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }]}
                onPress={() => {
                    this.props.self.setState({ currentTab: STRINGS.checkout });
                }}
            >
                <Text style={[AppStyles.loginButtonTextStyles, { fontSize: 16, fontFamily: AppStyles.fontFamily, fontWeight: '500' }]}>{STRINGS.checkout}</Text>
            </TouchableOpacity>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            width: width,
            minHeight: height,
            alignItems: "center",
            backgroundColor: '#F7F7F7',
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default CheckoutMini;
